//
import Service from '@/services/api/service'
import UserModel from '@/models/General/GUser'

//
export default class extends Service {

    //
    static includes = [
        'hr_employee',
        'roles',
    ]
    
    //
    static model = UserModel
}
